import {buildHreflangToLocaleCode} from './seoLocales'

export interface HrefLangLink {
  href: string
  hreflang: string
}

export interface SeoHrefLangLinks {
  hreflangLinks: HrefLangLink[]
}

/**
 * Builds `<link rel="alternate" hreflang>` entries for the active SEO locales
 * (the single source of truth is `buildHreflangToLocaleCode`) and a per-locale
 * path resolver. A locale with no resolvable path is skipped so we never emit an
 * alternate pointing at a non-existent URL.
 */
export const buildHreflangLinks = (
  baseUrl: string,
  activeLocales: string[],
  resolvePath: (localeCode: string) => string | undefined
): HrefLangLink[] =>
  Object.entries(buildHreflangToLocaleCode(activeLocales)).reduce<
    HrefLangLink[]
  >((links, [hreflang, localeCode]) => {
    const path = resolvePath(localeCode)
    if (path) links.push({href: `${baseUrl}${path}`, hreflang})
    return links
  }, [])
